import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Country codes data
const COUNTRY_CODES = [
  { code: '+91', country: 'India', flag: '🇮🇳', minLength: 10, maxLength: 10 },
  { code: '+1', country: 'USA/Canada', flag: '🇺🇸', minLength: 10, maxLength: 10 },
  { code: '+44', country: 'UK', flag: '🇬🇧', minLength: 10, maxLength: 11 },
  { code: '+61', country: 'Australia', flag: '🇦🇺', minLength: 9, maxLength: 9 },
  { code: '+971', country: 'UAE', flag: '🇦🇪', minLength: 9, maxLength: 9 },
  { code: '+65', country: 'Singapore', flag: '🇸🇬', minLength: 8, maxLength: 8 },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾', minLength: 9, maxLength: 10 },
  { code: '+49', country: 'Germany', flag: '🇩🇪', minLength: 10, maxLength: 11 },
  { code: '+33', country: 'France', flag: '🇫🇷', minLength: 9, maxLength: 9 },
  { code: '+39', country: 'Italy', flag: '🇮🇹', minLength: 10, maxLength: 10 },
  { code: '+81', country: 'Japan', flag: '🇯🇵', minLength: 10, maxLength: 11 },
  { code: '+86', country: 'China', flag: '🇨🇳', minLength: 11, maxLength: 11 },
  { code: '+82', country: 'South Korea', flag: '🇰🇷', minLength: 9, maxLength: 10 },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦', minLength: 9, maxLength: 9 },
  { code: '+974', country: 'Qatar', flag: '🇶🇦', minLength: 8, maxLength: 8 },
  { code: '+968', country: 'Oman', flag: '🇴🇲', minLength: 8, maxLength: 8 },
  { code: '+973', country: 'Bahrain', flag: '🇧🇭', minLength: 8, maxLength: 8 },
  { code: '+965', country: 'Kuwait', flag: '🇰🇼', minLength: 8, maxLength: 8 },
  { code: '+27', country: 'South Africa', flag: '🇿🇦', minLength: 9, maxLength: 9 },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬', minLength: 10, maxLength: 10 },
  { code: '+254', country: 'Kenya', flag: '🇰🇪', minLength: 9, maxLength: 9 },
  { code: '+55', country: 'Brazil', flag: '🇧🇷', minLength: 10, maxLength: 11 },
  { code: '+52', country: 'Mexico', flag: '🇲🇽', minLength: 10, maxLength: 10 },
  { code: '+63', country: 'Philippines', flag: '🇵🇭', minLength: 10, maxLength: 10 },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩', minLength: 10, maxLength: 12 },
  { code: '+66', country: 'Thailand', flag: '🇹🇭', minLength: 9, maxLength: 9 },
  { code: '+84', country: 'Vietnam', flag: '🇻🇳', minLength: 9, maxLength: 10 },
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰', minLength: 9, maxLength: 9 },
  { code: '+977', country: 'Nepal', flag: '🇳🇵', minLength: 10, maxLength: 10 },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩', minLength: 10, maxLength: 10 },
  { code: '+92', country: 'Pakistan', flag: '🇵🇰', minLength: 10, maxLength: 10 },
  { code: '+7', country: 'Russia', flag: '🇷🇺', minLength: 10, maxLength: 10 },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱', minLength: 9, maxLength: 9 },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭', minLength: 9, maxLength: 9 },
  { code: '+46', country: 'Sweden', flag: '🇸🇪', minLength: 9, maxLength: 9 },
  { code: '+47', country: 'Norway', flag: '🇳🇴', minLength: 8, maxLength: 8 },
  { code: '+45', country: 'Denmark', flag: '🇩🇰', minLength: 8, maxLength: 8 },
  { code: '+358', country: 'Finland', flag: '🇫🇮', minLength: 9, maxLength: 10 },
  { code: '+353', country: 'Ireland', flag: '🇮🇪', minLength: 9, maxLength: 9 },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿', minLength: 9, maxLength: 10 },
];

// Countries list for address
const COUNTRIES = [
  'India', 'United States', 'United Kingdom', 'Canada', 'Australia', 
  'UAE', 'Singapore', 'Malaysia', 'Germany', 'France', 'Italy', 
  'Japan', 'South Korea', 'Saudi Arabia', 'Qatar', 'Oman', 'Bahrain', 
  'Kuwait', 'South Africa', 'Nigeria', 'Kenya', 'Brazil', 'Mexico',
  'Philippines', 'Indonesia', 'Thailand', 'Vietnam', 'Sri Lanka',
  'Nepal', 'Bangladesh', 'Pakistan', 'Russia', 'Netherlands', 
  'Switzerland', 'Sweden', 'Norway', 'Denmark', 'Finland', 'Ireland',
  'New Zealand', 'Other'
];

// Common Indian cities for birth place
const BIRTH_PLACES = [
  "Delhi, India",
  "Mumbai, Maharashtra, India",
  "Bangalore, Karnataka, India",
  "Chennai, Tamil Nadu, India",
  "Kolkata, West Bengal, India",
  "Hyderabad, Telangana, India",
  "Pune, Maharashtra, India",
  "Ahmedabad, Gujarat, India",
  "Jaipur, Rajasthan, India",
  "Lucknow, Uttar Pradesh, India",
  "Chandigarh, India",
  "Patna, Bihar, India",
  "Bhopal, Madhya Pradesh, India",
  "Indore, Madhya Pradesh, India",
  "Nagpur, Maharashtra, India",
  "Surat, Gujarat, India",
  "Varanasi, Uttar Pradesh, India",
  "Kanpur, Uttar Pradesh, India",
  "Agra, Uttar Pradesh, India",
  "Noida, Uttar Pradesh, India",
  "Gurgaon, Haryana, India",
  "Ghaziabad, Uttar Pradesh, India",
  "Faridabad, Haryana, India",
  "Dehradun, Uttarakhand, India",
  "Amritsar, Punjab, India",
  "Ludhiana, Punjab, India",
  "Coimbatore, Tamil Nadu, India",
  "Kochi, Kerala, India",
  "Thiruvananthapuram, Kerala, India",
  "Visakhapatnam, Andhra Pradesh, India"
];

const BeginJourneyPage = () => {
  const [loading, setLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    countryCode: '+91',
    birth_date: '',
    birth_time: '',
    birth_place: '',
    gotra: '',
    question: '',
    delivery_country: 'India',
    delivery_city: '',
    delivery_postal_code: '',
    delivery_address: '',
    service_type: 'astro_analysis'
  });

  // Get selected country info for phone validation
  const getSelectedCountry = () => COUNTRY_CODES.find(c => c.code === formData.countryCode) || COUNTRY_CODES[0];
  const isPhoneValid = () => {
    const country = getSelectedCountry();
    return formData.phone.length >= country.minLength && formData.phone.length <= country.maxLength;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const includes = [
    { icon: "🔮", title: "Personalised Vedic Chart Analysis", desc: "A deep, birth-data-specific reading identifying the planetary root of your primary life challenge. Clear, written, jargon-free." },
    { icon: "⏱️", title: "Minimum 4 Hours of Analysis", desc: "Your chart receives dedicated study by an experienced Jyotish practitioner — not a quick glance or automated report." },
    { icon: "🎯", title: "Root Cause Identification", desc: "We identify the underlying planetary configuration behind your primary challenge — not surface symptoms, but the actual cause." },
    { icon: "🤝", title: "Explanation Before Remedy", desc: "What the chart shows is explained before any remedy is ever mentioned. Understanding comes first, always." },
    { icon: "✅", title: "Honest Assessment Guaranteed", desc: "If no significant challenge is found, we will tell you that — and charge you nothing additional. No invented problems." },
    { icon: "🚚", title: "Free Shipping Across India", desc: "Delivered within 5–7 working days. Securely packaged. Fully trackable." }
  ];

  return (
    <div data-testid="begin-journey-page">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Begin Your Journey - Vedic Astrology Consultation | Amatya</title>
        <meta name="description" content="Start your Vedic astrology journey with Amatya. Get personalized horoscope analysis, root cause identification, and honest spiritual guidance. Book your consultation today." />
        <meta name="keywords" content="Vedic astrology consultation, horoscope analysis, kundli reading, birth chart analysis, spiritual guidance, astrology booking" />
        <link rel="canonical" href="https://www.amatya.co.in/begin-journey" />
        <meta property="og:title" content="Begin Your Journey - Vedic Astrology Consultation | Amatya" />
        <meta property="og:description" content="Start your Vedic astrology journey. Get personalized horoscope analysis and honest spiritual guidance." />
        <meta property="og:url" content="https://www.amatya.co.in/begin-journey" />
      </Helmet>
      
      {/* Hero */}
      <div className="page-hero" data-testid="begin-hero">
        <div className="page-hero-content">
          <span className="page-hero-label">Begin Your Journey</span>
          <h1 className="page-hero-title">Your root cause<br/><em>analysis awaits.</em></h1>
          <p className="page-hero-sub">Complete the form below. We will study your chart with care, explain what we find, and offer only what is genuinely needed. No pressure. No fear. Just honest counsel.</p>
        </div>
      </div>

      {/* Consultation Section */}
      <section className="consult-page" data-testid="consult-section">
        <div className="wrap">
          <div className="consult-layout">
            {/* Left Column - What's Included */}
            <div className="reveal">
              <span className="section-label">What You Receive</span>
              <h2 className="section-title">Everything included<br/>in your ₹2,101 package</h2>
              <div className="consult-includes">
                {includes.map((item, i) => (
                  <div key={i} className="ci-item" data-testid={`include-${i}`}>
                    <span className="ci-icon">{item.icon}</span>
                    <div>
                      <div className="ci-title">{item.title}</div>
                      <div className="ci-desc">{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="consult-guarantee">
                <div className="cg-title">Our Guarantee to You</div>
                <div className="cg-body">If you feel your analysis was not conducted with genuine care and depth, contact us within 7 days. We will review it personally and respond honestly. Our reputation is built on individual acts of integrity — not on scale.</div>
              </div>
            </div>

            {/* Right Column - WhatsApp CTA */}
            <div className="consult-form-wrap reveal d2">
              <div className="consult-form" data-testid="consult-whatsapp-cta">
                <div className="form-title">Begin Your Analysis</div>
                <p className="form-sub">Share your birth details with us on WhatsApp. We will study your chart with care and respond personally — no automated replies, no hard-sell.</p>

                <div style={{display:'flex', alignItems:'center', justifyContent:'center', margin:'32px 0 24px'}}>
                  <div style={{textAlign:'center'}}>
                    <div style={{fontFamily:'Cinzel, serif', fontSize:'2.4rem', color:'#D4A843', fontWeight:'600', letterSpacing:'0.02em'}}>₹ 2,101</div>
                    <div style={{fontFamily:'Lato, sans-serif', fontSize:'0.72rem', letterSpacing:'0.14em', textTransform:'uppercase', color:'rgba(232,220,200,0.6)', marginTop:'4px'}}>Complete Package — Astro Analysis</div>
                  </div>
                </div>

                <a
                  href="https://wa.me/917633997555?text=Hi%20Amatya%2C%20I%20would%20like%20to%20book%20my%20Astro%20Analysis%20reading.%20Please%20share%20the%20next%20steps."
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="whatsapp-book-reading-btn"
                  className="form-submit"
                  style={{
                    display:'flex', alignItems:'center', justifyContent:'center', gap:'12px',
                    background:'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
                    color:'#fff', textDecoration:'none', padding:'18px 20px',
                    fontFamily:'Cinzel, serif', fontSize:'0.95rem', fontWeight:'600',
                    letterSpacing:'0.04em', boxShadow:'0 6px 24px rgba(18, 140, 126, 0.3)',
                    borderRadius:'4px', textAlign:'center', lineHeight:'1.35'
                  }}
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.464 3.488"/></svg>
                  Book Your Reading Now!!
                </a>

                <div style={{display:'flex', alignItems:'center', justifyContent:'center', gap:'8px', marginTop:'16px', fontFamily:'Lato, sans-serif', fontSize:'0.8rem', color:'rgba(232,220,200,0.65)'}}>
                  <span>📱</span>
                  <span>+91 7633 997 555</span>
                </div>

                <p className="form-note" style={{marginTop:'18px'}}>Your WhatsApp message reaches us directly. We respond personally — usually within a few hours.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BeginJourneyPage;
